/**
 * API 調用服務
 * 處理與後端 API 的所有互動
 */

const API_BASE_URL = import.meta.env.VITE_SITE_URL || '';

/**
 * 建立支付訂單
 * @param {Object} orderData - 訂單資料
 * @returns {Promise<Object>} 支付表單資料
 */
export async function createPaymentOrder(orderData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/payment/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
    });
    
    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || '建立訂單失敗');
    }
    
    return result;
  } catch (error) {
    console.error('建立支付訂單失敗:', error);
    throw error;
  }
}

/**
 * 提交支付表單到藍新金流
 * @param {string} gatewayUrl - 藍新金流網址
 * @param {Object} formData - 表單資料
 */
export function submitPaymentForm(gatewayUrl, formData) {
  // 建立隱藏的表單
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = gatewayUrl;
  
  // 加入表單欄位
  Object.keys(formData).forEach(key => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = formData[key];
    form.appendChild(input);
  });
  
  // 將表單加到 DOM 並提交
  document.body.appendChild(form);
  form.submit();
}

/**
 * 查詢訂單狀態
 * @param {string} orderNumber - 訂單編號
 * @param {string} email - 收件人 Email
 * @returns {Promise<Object>} 訂單資訊
 */
export async function getOrderStatus(orderNumber, email) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/order/status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ order_number: orderNumber, email }),
    });
    
    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || '查詢訂單失敗');
    }
    
    return result.order;
  } catch (error) {
    console.error('查詢訂單狀態失敗:', error);
    throw error;
  }
}

export default {
  createPaymentOrder,
  submitPaymentForm,
  getOrderStatus,
};
